export default __webpack_public_path__ + "static/media/E_02_01bg.54f4d57b.mp4";